import {Card, FormControl, Separator} from 'platform/components';
import {Heading, Text, VStack} from 'platform/foundation';

import {UseFormReturn} from 'react-hook-form';

import i18n from '@dms/i18n';

import {CurrencyCodeType, suffixTestId, TestIdProps} from 'shared/web';

import {DiscountSectionFormType} from '../schemas/discountSectionSchema';
import {DiscountOnMaterial} from './DiscountOnMaterial';
import {DiscountOnWork} from './DiscountOnWork';

interface CustomDiscountsCardProps extends TestIdProps {
  control: FormControl<DiscountSectionFormType>;
  formApi: UseFormReturn<DiscountSectionFormType>;
  currency?: CurrencyCodeType;
  isReadOnly?: boolean;
}

export function CustomDiscountsCard(props: CustomDiscountsCardProps) {
  return (
    <Card variant="inlineGrey">
      <VStack spacing={4}>
        <VStack spacing={1}>
          <Heading size={4}>{i18n.t('entity.order.labels.customDiscounts')}</Heading>
          <Text size="small" color="secondary">
            {i18n.t('entity.order.labels.discountInfo')}
          </Text>
        </VStack>
        <Separator spacing={0} />
        <DiscountOnWork
          control={props.control}
          formApi={props.formApi}
          currency={props.currency}
          isReadOnly={props.isReadOnly}
          data-testid={suffixTestId('work', props)}
        />
        <Separator spacing={0} />
        <DiscountOnMaterial
          control={props.control}
          formApi={props.formApi}
          isReadOnly={props.isReadOnly}
          data-testid={suffixTestId('material', props)}
        />
      </VStack>
    </Card>
  );
}
